// extracted by mini-css-extract-plugin
export var arrow = "BlogCard-module--arrow--2649f";
export var card = "BlogCard-module--card--e2109";
export var imageContainer = "BlogCard-module--image-container--e3a56";
export var link = "BlogCard-module--link--f2e50";
export var meta = "BlogCard-module--meta--75454";
export var title = "BlogCard-module--title--b0728";